import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
// import Intercom from '@intercom/messenger-js-sdk';

import useMediaQuery from "@mui/material/useMediaQuery";

import Footer from "../../components/Footer";
import Hero from "../../components/Hero";
import AddKpiBox from "../../components/YetiKpiBox/AddKpiBox";
import SoftTypography from "../../components/SoftTypography";
import SoftBox from "../../components/SoftBox";
import SoftButton from "../../components/SoftButton";
import { useNavigate } from "react-router-dom";
import onBoardingImage from "../../img/onBoarding.jpg";
import { UseSubscriptionLevel, UseSelectedWorkspace, UseCompanyColors, UseCompanyWorkspaces } from "../../hooks/company";
import { useOnlineStatus } from "../../hooks/useNetwork";
import { AVG_DAILY_REVENUE_ID, BEAT_YETI_RATE_ID, TECH_REVENUE_PER_HOUR_ID } from "../../hooks/useDerivedRevenueMetrics";
import { useSyncOfflineData } from "../../hooks/useSyncOfflineData";

import {
  UseUserDetails,
  UseIsDemo,
  UseLoading,
  UseIsAdmin,
  UseUpdateUserDetails,
  UseCompanyId,
} from "../../hooks/auth";
import moment from "moment";
import { UseLeaderboardGroupKpis, UseGroupKpis, UseDraftKpis, UseMyKpis, UseTopPlayers, useGetPreviousKpis, buildCompanyScoresByDay } from "../../hooks/kpi";
import { filterKpisForPublicDisplay } from "../../constants/kpi";
import { GET_ALL_USER_KPIS } from "../../api/kpi";
import { Skeleton } from "../../components/shared/Loading";
import LoadingScreen from "../../components/LoadingScreen";
import "./homepageStyles.css";
import { signOutUser } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { homePropmt, installApp } from "../../hooks/addToHome";
import { PUT_USER, GET_USER } from "../../api/user";
import { FETCH_BONUS_PROGRESS, SAVE_BONUS_CONFIG } from "../../api/group";
import { programFromConfig, configFromProgram, sanitizeProgram } from "../../components/SalesBonus/moneyRules";
import { isLiveMoneyRep, isAverageRep } from "../../helpers/teamAverage";
import { sanitizeMetricPlan } from "../../helpers/metricPlan";
import { recomputeClosedMonth, recomputeKpiCellPts } from "../../helpers/historicMonthBoard";
import { boundsForWindow, fetchWindowRates } from "../../helpers/windowRates";
import { BONUS_CONFIG_SAVED_EVENT } from "../../api/bonusConfigStore";
// import DemoOnboarding from "../../components/DemoOnboarding/DemoOnboarding";

import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses, Modal, Box, Grid } from '@mui/material';

// Customizable dashboard â€” registry-driven grid with per-workspace layouts.
import DashboardCanvas from "./customize/DashboardCanvas";
import { celebrateAdd, celebratePublish } from "./customize/celebrate";
import CustomizeDrawer from "./customize/CustomizeDrawer";
import TemplatePicker from "./customize/TemplatePicker";
import ConfirmWipe from "./customize/ConfirmWipe";
import LightSelect from "../CompanyView/LightSelect";
import RangeCalendar from "./customize/RangeCalendar";
import { widgetById, settingsFor, sizeKeyOf, sizeDims, PERIOD_TO_IDX, DEFAULT_LAYOUT, conformLayout, GRID_COLS, makeCustomId, isCustomId, customWidthFor, makeInstanceId, baseId } from "./customize/widgetRegistry";
import { loadLayout, publishLayout, sanitizeLayout } from "./customize/layoutStore";
import { normalizeYetiGoal, normalizeYetiGoals } from "../../helpers/beatYeti";
import "./customize/customize.css";

// The dashboard-wide period filter (in the navbar). Indexes match the
// UseTopPlayers order the leaderboard already uses.
const PERIOD_OPTIONS = [
  { value: 1, label: "Today" },
  { value: 0, label: "Yesterday" },
  { value: 2, label: "This Week" },
  { value: 4, label: "Last Week" },
  { value: 3, label: "This Month" },
  { value: 5, label: "Last Month" },
  { value: "custom", label: "Custom range" },
];

// periodIdx â†’ the score-bucket key used by UseMyKpis / UseTopPlayers / yeti
// stats, so the metric amounts on the board follow the navbar filter (not just
// the leaderboard/podium, which already read ctx.periodIdx).
const IDX_TO_BUCKET = { 0: "yesterday", 1: "today", 2: "week", 4: "lastWeek", 3: "month", 5: "lastMonth" };

// The navbar period → the scoped-metrics WINDOW id, so the game components
// (mountain, Yeti, Beat the Yeti) follow the same navbar filter the leaderboard
// already does. "custom" carries the calendar's dates through ctx.boardCustom.
const PERIOD_TO_WINDOW = {
  0: "yesterday",
  1: "today",
  2: "week",
  3: "month",
  4: "lastWeek",
  5: "lastMonth",
};

// Add this custom tooltip component
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 425,
    background: 'linear-gradient(180deg, #101828 0%, #39558E 100%)',
    boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.25)',
    color: '#101828',
  },
});

// Add this custom tooltip content component
const CustomTooltipContent = React.forwardRef(({ closeTooltip }, ref) => (
  <SoftBox ref={ref} sx={{ p: 2, textAlign: 'left !important' }}>
    <SoftTypography variant="h6" component="h3" sx={{ mb: 1, fontWeight: 'bold', color: "#FFFFFF" }}>
      King of the mountain
    </SoftTypography>
    <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
      Navigate seamlessly with our Sidebar. Access key sections like Players, Bad guy, Hub, and more.
    </SoftTypography>
    <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "2rem" }}>
      <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
        3/3
      </SoftTypography>
      <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SoftTypography variant="body2" sx={{color: "#FFFFFF", marginRight: "0.5rem", cursor: "pointer"}} onClick={closeTooltip}>
          Done
        </SoftTypography>
        <SoftButton
          variant="outlined"
          onClick={closeTooltip}
          sx={{
            background: "#FFFFFF",
            borderRadius: "4px",
            border: "1px solid #EAECF0",
            color: "#2152FF !important",
            textTransform: "capitalize !important",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
        >
          End Tutorial
        </SoftButton>
      </SoftBox>
    </SoftBox>
  </SoftBox>
));

// Add this new custom tooltip content component
const CustomTooltipContent2 = React.forwardRef(({ closeTooltip, onNext, isAdmin }, ref) => (
  <SoftBox ref={ref} sx={{ p: 2, textAlign: 'left !important' }}>
    <SoftTypography variant="h6" component="h3" sx={{ mb: 1, fontWeight: 'bold', color: "#FFFFFF" }}>
      {isAdmin ? "Team Performance VS. The Yeti" : "My Performance VS. The Yeti"}
    </SoftTypography>
    <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
      Widgets provide at-a-glance insights! Customize your dashboard with Widgets to monitor essential metrics and achievements
    </SoftTypography>
    <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "2rem" }}>
      <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
        2/3
      </SoftTypography>
      <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SoftTypography variant="body2" sx={{color: "#FFFFFF", marginRight: "0.5rem", cursor: "pointer"}} onClick={closeTooltip}>
          Skip Tutorial
        </SoftTypography>
        <SoftButton
          variant="outlined"
          sx={{
            background: "#FFFFFF",
            borderRadius: "4px",
            border: "1px solid #EAECF0",
            color: "#2152FF !important",
            textTransform: "capitalize !important",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
          onClick={onNext}
        >
          Next
        </SoftButton>
      </SoftBox>
    </SoftBox>
  </SoftBox>
));

function Homepage() {

  const isLoading = UseLoading();
  const isAdmin = UseIsAdmin();
  const { _id: userId, onboardingStatus, onboardingBannerDismissed, isAdmin: isRealAdmin, email: userEmail, firstName: userfirstName, lastName: userlastName, logins } = UseUserDetails();
  const isDemo = UseIsDemo();
  const groupKpis = UseLeaderboardGroupKpis();
  // Unfiltered lists for the money Setup drawer and custom cards: rules may pay
  // on metrics that are hidden from public boards or still drafts (no scores yet).
  const allGroupKpis = UseGroupKpis();
  const draftKpis = UseDraftKpis();
  const [kpis, setKpis] = useState([]);
  // Same per-KPI summary but over EVERY workspace metric, scorekeeper-only
  // included. Custom "Build your own" cards resolve their values from this
  // list: a metric hidden from public boards can still be deliberately picked
  // for a card, and it must render a real number there. Public widgets keep
  // reading `kpis` (filtered), so nothing leaks onto the leaderboard.
  const [kpisAll, setKpisAll] = useState([]);
  // Dashboard-wide period filter (navbar). 3 = This Month, the long-standing
  // default. Declared here so the KPI-summary effect below can follow it.
  const [globalPeriod, setGlobalPeriod] = useState(3);
  /* The navbar's own custom date range, live when globalPeriod === "custom".
     Scoped cards (Yeti, Milestones, Anticipated earnings) fetch by range and
     honour it; the bucket-based classic cards keep their nearest preset. */
  const [globalRange, setGlobalRange] = useState({ from: "", to: "" });
  const [rangeOpen, setRangeOpen] = useState(false);
  /* The board-wide workspace filter (the navbar "Viewing" control). "all" =
     every workspace on the board, or a specific workspace id. Only meaningful
     when a component on the board combines two or more workspaces. */
  const [boardWs, setBoardWs] = useState("all");
  /* "12 Jan" — a compact label for the chosen range on the navbar control. */
  const fmtShort = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-").map(Number);
    const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${d} ${MON[m - 1]}`;
  };
  /* The Custom range option carries the chosen dates as its label once applied,
     so the navbar reads "12 Jan – 20 Aug" instead of a bare "Custom range". */
  const periodOptions = useMemo(() => PERIOD_OPTIONS.map((o) => (
    o.value === "custom" && globalRange.from && globalRange.to
      ? { ...o, label: `${fmtShort(globalRange.from)} – ${fmtShort(globalRange.to)}` }
      : o
  )), [globalRange]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSubscribed = UseSubscriptionLevel();
  const [showDemo, setShowDemo] = useState(
    isDemo && onboardingStatus !== "completed",
  );
  const [bannerDismissed, setBannerDismissed] = useState(onboardingBannerDismissed);
  const userKpis = UseMyKpis();
  const { getPreviousKpis } = useGetPreviousKpis();
  const lastMonthMoment = useMemo(() => moment().subtract(1, "month").startOf("month"), []);
  const lastMonthKey = lastMonthMoment.format("YYYY-MM");
  const historicKpisLastMonth = useSelector(
    (state) => state.kpiReducer.historicKpis?.[lastMonthKey],
  );
  useEffect(() => {
    if (globalPeriod === 5 && (allGroupKpis?.length || groupKpis?.length)) {
      getPreviousKpis(lastMonthMoment, !Array.isArray(historicKpisLastMonth));
    }
  }, [globalPeriod, lastMonthMoment, getPreviousKpis, allGroupKpis, groupKpis, historicKpisLastMonth]);
  const lastMonthHistoricPending = globalPeriod === 5 && !Array.isArray(historicKpisLastMonth);
  const [lastMonthWindowRates, setLastMonthWindowRates] = useState(null);
  const isOnline = useOnlineStatus();
  const { syncOfflineData } = useSyncOfflineData();

  useEffect(() => {
    const handlePageFullyLoaded = () => {
      if (isOnline) {
        syncOfflineData(isOnline);
      }
    };
    if (document.readyState === 'complete') {
      handlePageFullyLoaded();
    } else {
      window.addEventListener('load', handlePageFullyLoaded);
      return () => window.removeEventListener('load', handlePageFullyLoaded);
    }
  }, [isOnline, syncOfflineData]);

  // Intercom({
  //   app_id: 'xpad1tsg',
  //   name: `${userfirstName} ${userlastName}`,
  //   email: userEmail
  // })

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isBelowLg = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const [isVisible, setIsVisible] = useState(() => {
    console.log("onboardingBannerDismissed for this user?:", onboardingBannerDismissed);
    console.log("undefined?", onboardingBannerDismissed === undefined);
    console.log("isVisible initial state:", !onboardingBannerDismissed || true);
    if (onboardingBannerDismissed === undefined) {
      return true; // Default to visible if the value is undefined
    } else if (onboardingBannerDismissed === false) {
      return true; // Show the banner if it has not been dismissed
    } else if (onboardingBannerDismissed === true) {
      return false; // Hide the banner if it has been dismissed
    }
  });

  const handleHide = async () => {
    setIsVisible(false);
    try {
      const response = await PUT_USER(userId, { onboardingBannerDismissed: true }, true);
      if (response.status === 200) {
        console.log("User onboarding status updated successfully");
      }
    } catch (error) {
      console.error("Error updating user onboarding status:", error);
    }
    dispatch({
      type: "UPDATE_USER_DETAILS",
      payload: {
      onboardingBannerDismissed: true
      }
    });
  };


  useEffect(() => {
    if (!isLoading) {
      if (!userId) {
        dispatch(signOutUser());
        window.sessionStorage.removeItem("hasRunBlackout");
        document.location.href = "/";
      }
    }
  }, [isLoading, userKpis, userId]);

  useEffect(() => {
    if (groupKpis) {
      // Follow the navbar period filter â€” pick the matching bucket so the
      // metric amounts on the board change with it. UseMyKpis gives players
      // all four buckets, but the ADMIN team-average is only computed for
      // month, so fall back to month when the wanted bucket isn't present
      // (never blank the cards to 0). Extending admin averages to the other
      // periods is a data-layer change (see fetchKpiData / UseMyKpis).
      const wanted = IDX_TO_BUCKET[globalPeriod] || "month";
      let bucket = userKpis?.[wanted] ? wanted : "month";
      let scoreBucket = bucket;
      if (wanted === "lastMonth") {
        bucket = "lastMonth";
        scoreBucket = "month";
      }
      const historicRow = wanted === "lastMonth"
        ? historicKpisLastMonth?.find((u) => String(u.userId) === String(userId))
        : null;
      const scores = wanted === "lastMonth" ? historicRow?.month : userKpis?.[scoreBucket];
      if (wanted === "lastMonth" && !scores) {
        bucket = "month";
      } else if (wanted !== "lastMonth" && !userKpis?.[bucket]) {
        bucket = "month";
        scoreBucket = "month";
      }
      const recomputedMonth = wanted === "lastMonth" && scores
        ? recomputeClosedMonth(scores, allGroupKpis || [])
        : null;
      const ownerRates = wanted === "lastMonth"
        ? lastMonthWindowRates?.[String(userId)]
        : null;
      const fullSummary = (allGroupKpis || []).filter(kpi => !kpi.isDraft).map((kpiItem) => {
        const id = String(kpiItem._id);
        const windowCell = ownerRates?.[id] || ownerRates?.[kpiItem._id];
        let amount = wanted === "lastMonth"
          ? (recomputedMonth?.[kpiItem._id]?.amt ?? scores?.[kpiItem._id]?.amt ?? 0)
          : (userKpis?.[scoreBucket])?.[kpiItem._id]?.amt ?? 0;
        let points = wanted === "lastMonth"
          ? (recomputedMonth?.[kpiItem._id]?.pts ?? recomputeKpiCellPts(scores?.[kpiItem._id], kpiItem))
          : (userKpis?.[scoreBucket])?.[kpiItem._id]?.pts ?? 0;
        if (windowCell) {
          amount = Number(windowCell.amt) || 0;
          points = Number(windowCell.pts) || 0;
        }
        return {
          ...kpiItem,
          amount,
          points,
          target: kpiItem.target,
        };
      });
      setKpisAll(fullSummary);
      setKpis(filterKpisForPublicDisplay(fullSummary));
    }
  }, [groupKpis, allGroupKpis, userKpis, globalPeriod, historicKpisLastMonth, userId, lastMonthWindowRates]);

  // Per-period KPI summaries so the dashboard's Today / Yesterday / This Week
  // filter reaches every widget, not just the leaderboard. Player accounts read
  // their own score buckets; admin accounts average the active scorers per KPI
  // â€” the same convention UseMyKpis applies to the month bucket.
  const topPlayersYesterday = UseTopPlayers("yesterday");
  const topPlayersToday = UseTopPlayers("today");
  const topPlayersWeek = UseTopPlayers("week");
  const topPlayersLastWeek = UseTopPlayers("lastWeek");
  const topPlayersLastMonth = UseTopPlayers("month", lastMonthMoment);
  const topPlayers = UseTopPlayers("month");
  /* Head of Sales–style host: no one scoring here. Used as a fallback signal;
     the stronger rollup check is below (host id not in boardWorkspaces). */
  const emptyHost = !(topPlayers || []).some(
    (p) => p
      && p.isActive !== false
      && p.lastName !== "Yeti"
      && !p.isYeti
      && Number(p.scores?.total) > 0,
  );
  // Built over the UNFILTERED metric list so custom cards can follow the
  // period filter for scorekeeper-only metrics too; the public (filtered)
  // view is derived from it below.
  const kpisAllByPeriod = useMemo(() => {
    const base = (allGroupKpis || []).filter((kpi) => !kpi.isDraft);
    const topByBucket = {
      yesterday: topPlayersYesterday,
      today: topPlayersToday,
      week: topPlayersWeek,
      lastWeek: topPlayersLastWeek,
    };
    const forBucket = (bucket) => {
      if (bucket === "month") return kpisAll;
      if (bucket === "lastMonth") {
        // Score Last Month against the workspace KPI set (same as This Month),
        // not a cross-workspace "any KPI with a score" superset.
        const scoring = base;
        const applyLastMonthRates = (rows) => {
          if (!lastMonthWindowRates) return rows;
          const liveIds = isAdmin
            ? new Set(
              (topPlayersLastMonth || [])
                .filter((p) => !p.isYeti && p.isActive !== false)
                .map((p) => String(p.userId)),
            )
            : new Set([String(userId)]);
          return rows.map((kpiItem) => {
            const id = String(kpiItem._id);
            let amt = 0;
            let pts = 0;
            let n = 0;
            Object.entries(lastMonthWindowRates).forEach(([ownerId, rates]) => {
              if (liveIds.size && !liveIds.has(String(ownerId))) return;
              const cell = rates[id] || rates[kpiItem._id];
              if (!cell) return;
              amt += Number(cell.amt) || 0;
              pts += Number(cell.pts) || 0;
              n += 1;
            });
            if (!n) return kpiItem;
            return {
              ...kpiItem,
              amount: amt / n,
              points: pts / n,
            };
          });
        };
        if (isAdmin) {
          const players = (topPlayersLastMonth || [])
            .filter((p) => !p.isYeti && p.isActive !== false)
            .map((p) => ({
              ...p,
              scores: recomputeClosedMonth(p.scores, scoring),
            }));
          return applyLastMonthRates(base.map((kpiItem) => {
            const scorers = players.filter((p) => p.scores?.[kpiItem._id]);
            const amt = scorers.reduce((s, p) => s + (p.scores[kpiItem._id]?.amt || 0), 0);
            const pts = scorers.reduce(
              (s, p) => s + (Number(p.scores[kpiItem._id]?.pts) || 0),
              0,
            );
            return {
              ...kpiItem,
              amount: scorers.length ? amt / scorers.length : 0,
              points: scorers.length ? pts / scorers.length : 0,
              target: kpiItem.target,
            };
          }));
        }
        const myRow = historicKpisLastMonth?.find((u) => String(u.userId) === String(userId));
        const myScoped = myRow?.month
          ? recomputeClosedMonth(myRow.month, scoring)
          : null;
        return applyLastMonthRates(base.map((kpiItem) => ({
          ...kpiItem,
          amount: myScoped?.[kpiItem._id]?.amt ?? myRow?.month?.[kpiItem._id]?.amt ?? 0,
          points: myScoped?.[kpiItem._id]?.pts ?? recomputeKpiCellPts(myRow?.month?.[kpiItem._id], kpiItem),
          target: kpiItem.target,
        })));
      }
      if (isAdmin) {
        const players = (topByBucket[bucket] || []).filter(
          (p) => !p.isYeti && p.isActive !== false,
        );
        return base.map((kpiItem) => {
          const scorers = players.filter((p) => p.scores?.[kpiItem._id]);
          const amt = scorers.reduce((s, p) => s + (p.scores[kpiItem._id]?.amt || 0), 0);
          const pts = scorers.reduce((s, p) => s + (p.scores[kpiItem._id]?.pts || 0), 0);
          return {
            ...kpiItem,
            amount: scorers.length ? amt / scorers.length : 0,
            points: scorers.length ? pts / scorers.length : 0,
            target: kpiItem.target,
          };
        });
      }
      return base.map((kpiItem) => ({
        ...kpiItem,
        amount: userKpis?.[bucket]?.[kpiItem._id]?.amt ?? 0,
        points: userKpis?.[bucket]?.[kpiItem._id]?.pts ?? 0,
        target: kpiItem.target,
      }));
    };
    return {
      yesterday: forBucket("yesterday"),
      today: forBucket("today"),
      week: forBucket("week"),
      lastWeek: forBucket("lastWeek"),
      lastMonth: forBucket("lastMonth"),
      month: kpisAll,
    };
  }, [allGroupKpis, kpisAll, userKpis, isAdmin, userId, historicKpisLastMonth, lastMonthWindowRates, topPlayersYesterday, topPlayersToday, topPlayersWeek, topPlayersLastWeek, topPlayersLastMonth]);
  const kpisByPeriod = useMemo(() => ({
    yesterday: filterKpisForPublicDisplay(kpisAllByPeriod.yesterday),
    today: filterKpisForPublicDisplay(kpisAllByPeriod.today),
    week: filterKpisForPublicDisplay(kpisAllByPeriod.week),
    lastWeek: filterKpisForPublicDisplay(kpisAllByPeriod.lastWeek),
    lastMonth: filterKpisForPublicDisplay(kpisAllByPeriod.lastMonth),
    month: kpis,
  }), [kpisAllByPeriod, kpis]);

  useEffect(() => {
    const targetNode = document.getElementById("root");
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(() => {
      if (document.getElementById("ConfirmationModelSuccessBtn")) {
        installApp();
        observer.disconnect();
      } else if (document.getElementById("addToHomeClick")) {
        homePropmt();
      }
    });
    observer.observe(targetNode, config);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [openModal, setOpenModal] = useState(false);
  const [triggerTooltip, setTriggerTooltip] = useState(false);

  useEffect(() => {
    if (logins === 0 && isSubscribed > 0) {
      setOpenModal(true);
    }
  }, [logins, isSubscribed]);

  const handleCloseModal = () => {
    setOpenModal(false);
    setTriggerTooltip(true);
  };

  const handleCloseModal2 = () => {
    setOpenModal(false);
    handleHide();
  };

  const style = {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px',
    boxShadow: 24,
    padding: '1.75rem',
    maxWidth: { mini: "90%", xs: "90%", sm: "600px" },
    width: "100%",
    overflow: "visible",
    background: "#FFF !important"
  };

  const [openGameboardTooltip, setOpenGameboardTooltip] = useState(false);
  const [openYetiTooltip, setOpenYetiTooltip] = useState(false);

  const handleNextTooltip2 = () => {
    setOpenYetiTooltip(false);
    setOpenGameboardTooltip(true);
  };

  const handleNextTooltip = () => {
    setOpenYetiTooltip(true);
  };

  const handleCloseTooltip = () => {
    handleHide();
  };


  const closeGameboardTooltip = () => {
    setOpenGameboardTooltip(false);
    handleHide();
  };

  const closeYetiTooltip = () => {
    setOpenYetiTooltip(false);
    handleHide();
  };

  /* â”€â”€ Customizable dashboard â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
     The blocks live in customize/widgetRegistry.jsx; the layout is stored
     per workspace (admin publishes, every player sees it). Until a layout
     is published the board is DEFAULT_LAYOUT â€” today's dashboard, 1:1. */
  const workspace = UseSelectedWorkspace();

  /* Last month Closed Rate / Bid Accuracy — recompute for that calendar month. */
  useEffect(() => {
    if (globalPeriod !== 5 || !workspace?._id) {
      setLastMonthWindowRates(null);
      return undefined;
    }
    let alive = true;
    const { from, to } = boundsForWindow("lastMonth");
    fetchWindowRates({ groupId: workspace._id, from, to }).then((rates) => {
      if (alive) setLastMonthWindowRates(rates);
    });
    return () => { alive = false; };
  }, [globalPeriod, workspace?._id, lastMonthKey]);
  const allWorkspaces = UseCompanyWorkspaces(true);
  const companyId = UseCompanyId();
  const { primaryColor } = UseCompanyColors() || {};

  const [savedLayout, setSavedLayout] = useState(null); // null â†’ default
  /* false until loadLayout resolves for the current workspace. Without this,
     hard-refresh on Head of Sales briefly renders DEFAULT_LAYOUT (no
     workspaceIds) and every scoped card binds to the empty host — zeros that
     stick until you visit Sales and come back. */
  const [layoutReady, setLayoutReady] = useState(false);
  const [bonus, setBonus] = useState(null); // sales bonus progress for the sales cards
  const [draft, setDraft] = useState(null);
  const [editing, setEditing] = useState(false);
  // The id of a just-added block, so its card plays a one-shot pop-in on the
  // board. Cleared after the animation so a re-render never replays it.
  const [popId, setPopId] = useState(null);
  const popTimer = useRef(null);
  // The component open in the drawer's editor. `pending` means it is not on the
  // board yet â€” a dashed ghost card stands in for it until you confirm.
  const [editTarget, setEditTarget] = useState(null); // { id, draft, pending }
  /* Creating used to be blind: nothing existed anywhere until "Add to board".
     Now the create form has a live dashed card on the board from its first
     click — this holds its minted id, the form's current draft, and the width
     chosen on the size pictures. Same idea as a pending editTarget; separate
     state because the create form is not the editor. */
  const [createGhost, setCreateGhost] = useState(null); // { id, draft, w }

  /* The workspace's pay program (commission + bonus rules + the ladder).
     It is NOT part of the dashboard layout: money is one truth per workspace,
     so two admins with the card on different boards can never see different
     pay. Edited in the drawer's Setup tab, saved to bonusConfig. */
  const [program, setProgram] = useState(null);
  const [programDirty, setProgramDirty] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [templateOpen, setTemplateOpen] = useState(false);
  /* Which side of the panel is showing. It used to be a menu you opened; now it
     is a tab in the bar, so this is the single source of what the panel renders
     and which tab reads as selected. */
  const [panelTab, setPanelTab] = useState("components");

  // Edit mode owns the top bar: a body class tints it and hides the bell/gear
  // (see customize.css) so editing reads as its own mode, not controls crammed
  // next to the persistent icons.
  useEffect(() => {
    document.body.classList.toggle("gmb-dash-editing", editing);
    return () => document.body.classList.remove("gmb-dash-editing");
  }, [editing]);
  // The page's controls live in the top navbar — TopBar exposes two portal
  // slots (left: status chip · right: actions) that only this page fills.
  const [navSlotLeft, setNavSlotLeft] = useState(null);
  const [navSlotRight, setNavSlotRight] = useState(null);
  useEffect(() => {
    setNavSlotLeft(document.getElementById("gmbw-topbar-slot-left"));
    setNavSlotRight(document.getElementById("gmbw-topbar-slot"));
  }, []);

  useEffect(() => {
    let alive = true;
    setEditing(false);
    setDrawerOpen(false);
    setTemplateOpen(false);
    setDraft(null);
    setLayoutReady(false);
    if (!workspace?._id) {
      setSavedLayout(null);
      setLayoutReady(true);
      return undefined;
    }
    loadLayout(companyId, workspace._id).then((saved) => {
      if (!alive) return;
      setSavedLayout(saved && saved.length ? conformLayout(saved) : null);
      setLayoutReady(true);
    });
    return () => { alive = false; };
  }, [companyId, workspace?._id]);

  // Sales bonus progress (earnings + milestone cards). Scoped to the selected
  // workspace; the server returns the whole roster for admins, just the caller's
  // row for a player.
  //
  // Re-fetches on mount AND whenever the ladder is saved in Team Room â†’
  // "Milestones & bonuses" â€” via a same-tab event and the cross-tab `storage`
  // event. Without those, a dashboard that was already open kept showing the
  // old ladder after a save (it only ever fetched once, on mount), which reads
  // exactly like "I saved it and it didn't reflect".
  useEffect(() => {
    let alive = true;
    if (!workspace?._id) {
      setBonus(null);
      return undefined;
    }
    const load = () => {
      FETCH_BONUS_PROGRESS(workspace._id)
        .then((res) => {
          if (!alive || !res) return;
          setBonus({
            ...res,
            myId: userId,
            connected: !!(res.config && res.config.revenueKpiId),
          });
          // Only adopt the stored program while the admin has no unsaved edits,
          // so a background refetch can never wipe what they are typing.
          setProgramDirty((dirty) => {
            if (!dirty) setProgram(programFromConfig(res.config));
            return dirty;
          });
        })
        .catch(() => alive && setBonus(null));
    };
    load();
    const onSaved = () => load();
    window.addEventListener(BONUS_CONFIG_SAVED_EVENT, onSaved);
    return () => {
      alive = false;
      window.removeEventListener(BONUS_CONFIG_SAVED_EVENT, onSaved);
    };
  }, [workspace?._id, userId]);

  const brandVars = useMemo(() => {
    const base = primaryColor || "#1B598E";
    let hex = base.replace("#", "").trim();
    if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return {
      "--gmbw-primary": base,
      "--gmbw-primary-hover": `rgb(${Math.round(r * 0.88)}, ${Math.round(g * 0.88)}, ${Math.round(b * 0.88)})`,
      "--gmbw-primary-soft": `rgba(${r}, ${g}, ${b}, 0.10)`,
    };
  }, [primaryColor]);

  let activeLayout = [];
  if (editing && draft) activeLayout = draft;
  else if (layoutReady) activeLayout = savedLayout || DEFAULT_LAYOUT;

  /* Which workspaces the board actually combines. A card is "cross-workspace"
     when its saved settings name two or more workspaces; the navbar Viewing
     filter appears only when at least one card does, and lists the union of
     those workspaces. Declared early so Save/Publish can stamp these ids onto
     empty-host cards (KOTM/Yeti) instead of wiping them. */
  const boardWorkspaces = useMemo(() => {
    const ids = new Set();
    (activeLayout || []).forEach((b) => {
      const s = settingsFor(b);
      const ws = Array.isArray(s.workspaceIds) ? s.workspaceIds.filter(Boolean).map(String) : [];
      if (ws.length >= 2) ws.forEach((id) => ids.add(id));
    });
    return [...ids];
  }, [activeLayout]);
  const hasCombined = boardWorkspaces.length >= 2;

  /* What else is on this board, for the one card that reads another: Revenue,
     Expenses & Labor takes its Labor figure from a Payroll vs Revenue card
     sitting beside it, so it has to be able to see (and name) its siblings.
     A block's registry id IS its component here (baseId drops the "#2" a
     duplicate carries), unlike the Analytics board where comp is a field. */
  const boardWidgets = useMemo(
    () => (activeLayout || []).map((b) => ({
      id: b.i,
      comp: baseId(b.i),
      title: settingsFor(b)?.title || "",
      options: settingsFor(b) || {},
    })),
    [activeLayout],
  );
  /* Sources to inherit = combined workspaces MINUS this host. Head of Sales
     combining Sales+In-House → inherit [Sales, In-House]. A real Sales board
     that also pools Sales+In-House → inheritSources is just [In-House] (length 1)
     so Yeti keeps reading Sales. Always inherit when the host is not itself a
     source (rollup), or when the host has no scored players. */
  const hostId = workspace?._id ? String(workspace._id) : null;
  const inheritSources = useMemo(
    () => (hostId ? boardWorkspaces.filter((id) => id !== hostId) : boardWorkspaces),
    [boardWorkspaces, hostId],
  );
  const isRollupHost = hasCombined && !!hostId && !boardWorkspaces.includes(hostId);
  const shouldInherit = inheritSources.length >= 2 && (isRollupHost || emptyHost);

  // A component being set up is drawn where it will land, so there is something
  // real to watch while you type — but it is not in the draft until you confirm.
  const ghostId = editing ? ((editTarget?.pending && editTarget.id) || createGhost?.id || null) : null;
  const ghostSize = editTarget?.size || "standard";
  const boardLayout = useMemo(() => {
    if (!ghostId) return activeLayout;
    const def = widgetById(ghostId);
    if (!def || activeLayout.some((b) => b.i === ghostId)) return activeLayout;
    let dims = sizeDims(ghostId, ghostSize) || { w: def.defaultW, h: def.defaultH };
    if (createGhost && ghostId === createGhost.id) {
      // The create ghost is sized by its content (and the size pictures), the
      // same rule the real card will follow the moment it lands.
      const floor = customWidthFor(createGhost.draft);
      dims = { w: Math.max(createGhost.w || floor, floor), h: def.defaultH };
    }
    const bottom = activeLayout.reduce((max, b) => Math.max(max, b.y + b.h), 0);
    return [...activeLayout, { i: ghostId, x: 0, y: bottom, w: dims.w, h: dims.h }];
  }, [activeLayout, ghostId, ghostSize, createGhost]);

  const startEditing = () => {
    setDraft(conformLayout(savedLayout || DEFAULT_LAYOUT).map((blk) => ({ ...blk })));
    setEditing(true);
  };

  const cancelEditing = () => {
    setEditing(false);
    setDrawerOpen(false);
    setTemplateOpen(false);
    setDraft(null);
    setEditTarget(null);
    if (programDirty) {
      setProgram(programFromConfig(bonus?.config));
      setProgramDirty(false);
    }
  };

  // Drop a template's layout onto the draft (replacing what's there). An empty
  // array = the Blank canvas choice.
  const applyTemplate = (layout) => {
    setDraft(conformLayout(layout).map((blk) => ({ ...blk })));
    setEditTarget(null);
  };

  // Anything that replaces the whole board asks first â€” and names what goes.
  // It never asks when the board is empty: a confirm on a no-op only teaches
  // people to click through the next one.
  const [wipe, setWipe] = useState(null); // { what, layout, confirmLabel }
  const boardTitles = () => (draft || []).map((b) => widgetById(b.i)?.title).filter(Boolean);

  const requestWipe = (what, layout, confirmLabel) => {
    if (!(draft || []).length) {
      applyTemplate(layout);
      return;
    }
    setWipe({ what, layout, confirmLabel });
  };

  /* Build the settings object (`s`) a block should store for an editor draft.
     ONE place, used by both "Save changes" and Publish-mid-edit: when these two
     drifted apart, whole fields (hide toggles, chip labels) silently vanished
     on whichever path was missing them. Returns undefined when nothing beyond
     the defaults was set. */
  const cleanSettingsFrom = (def, next) => {
    const clean = {};
    if (next.title && next.title.trim() && next.title.trim() !== def?.title) clean.title = next.title.trim();
    if (next.scene && next.scene !== def?.defaultScene) clean.scene = next.scene;
    if (next.period) clean.period = next.period;
    // Keep only the parts actually switched off ({ key: true }); an all-shown
    // card stores no `hide` at all, so untouched boards are unaffected.
    if (next.hide) {
      const off = Object.keys(next.hide).filter((k) => next.hide[k]);
      if (off.length) clean.hide = off.reduce((o, k) => ({ ...o, [k]: true }), {});
    }
    // Per-part display labels â€” only the ones actually typed; blank = default.
    if (next.labels) {
      const typed = Object.keys(next.labels)
        .filter((k) => typeof next.labels[k] === "string" && next.labels[k].trim())
        .reduce((o, k) => ({ ...o, [k]: next.labels[k].trim().slice(0, 40) }), {});
      if (Object.keys(typed).length) clean.labels = typed;
    }
    /* Scoped cards (scope), the money cards (earnings/milestones, which show the
       same workspace/show/range picker), and the cross-workspace leaderboard
       (board) all carry which workspaces they read; scope/money cards add the
       date window and average/total. This is a whitelist, so a setting left
       unnamed here is silently dropped the moment it is saved. */
    if (def?.scope || def?.board || def?.money) {
      if (Array.isArray(next.workspaceIds) && next.workspaceIds.length) {
        clean.workspaceIds = next.workspaceIds.map(String);
      }
      if (next.filterBy === "player") clean.filterBy = "player";
      if (next.window && next.window !== "follow") clean.window = next.window;
      if (next.window === "custom" && next.customRange) clean.customRange = next.customRange;
      if (next.avgMode === "total") clean.avgMode = "total";
      if (next.cardPick && next.cardPick !== "all") clean.cardPick = next.cardPick;
      /* Which metrics combine across the workspaces (auto by name, or paired by
         hand with a per-column sum/avg). Dropped here = the card reverts to the
         name-match the instant it saves. */
      const mp = sanitizeMetricPlan(next.metricPlan);
      if (mp) clean.metricPlan = mp;
    }
    /* The cross-workspace leaderboard's own rules: whether it pools several
       workspaces (across), how it ranks, and how it rotates on a TV. Missing
       from here, the board dropped `across`/`workspaceIds` the instant it was
       saved and reverted to a single-workspace ranking — empty on a workspace
       that tracks no metrics of its own (e.g. Head of Sales). */
    if (def?.board) {
      if (next.across === true) clean.across = true;
      if (next.rankBy) clean.rankBy = next.rankBy;
      if (next.rankOrder === "asc") clean.rankOrder = "asc";
      if (next.tieBreak) clean.tieBreak = next.tieBreak;
      if (next.yetiQualify === true) clean.yetiQualify = true;
      if (next.yetiQualify === false) clean.yetiQualify = false;
      const yqNeed = Number(next.yetiQualifyNeed);
      if (Number.isFinite(yqNeed) && yqNeed > 0) clean.yetiQualifyNeed = Math.min(12, Math.round(yqNeed));
      if (next.whoAppears === "active") clean.whoAppears = "active";
      const rowsN = Number(next.rows);
      if (Number.isFinite(rowsN) && rowsN > 0) clean.rows = rowsN;
      if (next.tvRotate === "rotate" || next.tvRotate === "topfit") clean.tvRotate = next.tvRotate;
      if (Number(next.tvRotateSize) > 0) clean.tvRotateSize = Number(next.tvRotateSize);
      if (Number(next.tvRotateSecs) > 0) clean.tvRotateSecs = Number(next.tvRotateSecs);
    }
    // "Build your own" widgets carry their metric rows, bonus and layout.
    if (def?.custom) {
      if (Array.isArray(next.metrics) && next.metrics.length) clean.metrics = next.metrics;
      if (next.bonus) clean.bonus = next.bonus;
      if (next.look) clean.look = next.look;
      if (next.show) clean.show = next.show;
      if (next.show && next.showOn) clean.showOn = next.showOn;
      if (next.who === false) clean.who = false;
      if (next.period) clean.period = next.period;
      if (next.period === "custom" && next.customRange) clean.customRange = next.customRange;
      if (next.yetiByTeam === true) clean.yetiByTeam = true;
      if (next.yetiBar === true) clean.yetiBar = true;
      const yetiGoal = normalizeYetiGoal(next.yetiGoal);
      if (yetiGoal) clean.yetiGoal = yetiGoal;
      const yetiGoals = normalizeYetiGoals(next.yetiGoals);
      if (Object.keys(yetiGoals).length) clean.yetiGoals = yetiGoals;
      // Technicians' Revenue per Hour's own goal, $/hr.
      if (Number(next.rphGoal) > 0) clean.rphGoal = Number(next.rphGoal);
    }
    return Object.keys(clean).length ? clean : undefined;
  };

  /* Merge cleaned editor fields onto the block's existing `s` instead of
     replacing it. Replacing was the Save/Publish wipe: opening KOTM (or Yeti)
     rebuilt a draft with empty workspaceIds via settingsFor, cleanSettingsFrom
     omitted them, and the write dropped every previously saved workspace pick
     — so after Publish the mountain went blank while the leaderboard (which
     still had across+ids) kept working. Explicit clears from the draft still
     remove keys; untouched keys from the previous save survive. */
  const mergeBlockSettings = (def, prevS, next, stampWorkspaceIds = []) => {
    const cleaned = cleanSettingsFrom(def, next);
    const merged = { ...(prevS && typeof prevS === "object" ? prevS : {}), ...(cleaned || {}) };

    if (def?.scope || def?.board || def?.money) {
      if (Array.isArray(next.workspaceIds) && next.workspaceIds.filter(Boolean).length === 0) {
        delete merged.workspaceIds;
      }
      if (next.window === "follow" || next.window === "" || next.window == null) {
        delete merged.window;
        delete merged.customRange;
      }
      if (next.avgMode !== "total") delete merged.avgMode;
      if (next.filterBy !== "player") delete merged.filterBy;
      if (!next.cardPick || next.cardPick === "all") delete merged.cardPick;
      if (!sanitizeMetricPlan(next.metricPlan)) delete merged.metricPlan;
    }
    if (def?.board && next.across !== true) delete merged.across;
    if (def?.custom) {
      if (!Array.isArray(next.metrics) || !next.metrics.length) delete merged.metrics;
      if (!next.bonus) delete merged.bonus;
      if (!next.look) delete merged.look;
      if (!next.show) {
        delete merged.show;
        delete merged.showOn;
      }
      if (next.who !== false) delete merged.who;
      /* The hand-picked list is retired (rows follow the tracked workspaces), and
         each switch stores only its on-state. */
      delete merged.yetiTeams;
      if (next.yetiByTeam !== true) delete merged.yetiByTeam;
      if (next.yetiBar !== true) delete merged.yetiBar;
      if (!normalizeYetiGoal(next.yetiGoal)) delete merged.yetiGoal;
      if (!Object.keys(normalizeYetiGoals(next.yetiGoals)).length) delete merged.yetiGoals;
      if (!(Number(next.rphGoal) > 0)) delete merged.rphGoal;
    }
    if (!next.title || !String(next.title).trim() || String(next.title).trim() === def?.title) {
      delete merged.title;
    }
    if (!next.scene || next.scene === def?.defaultScene) delete merged.scene;
    if (!next.period) delete merged.period;
    if (!next.hide || !Object.keys(next.hide).some((k) => next.hide[k])) delete merged.hide;
    if (!next.labels || !Object.keys(next.labels).some((k) => typeof next.labels[k] === "string" && next.labels[k].trim())) {
      delete merged.labels;
    }

    /* Empty-host board (Head of Sales): if this scoped card still has no
       workspace pick after the merge, stamp the board's combined workspaces so
       Publish persists them and the card does not depend on runtime inherit. */
    if (
      (def?.scope || def?.board || def?.money)
      && !(Array.isArray(merged.workspaceIds) && merged.workspaceIds.length)
      && Array.isArray(stampWorkspaceIds)
      && stampWorkspaceIds.length >= 2
    ) {
      merged.workspaceIds = stampWorkspaceIds.map(String);
      if (def?.board) merged.across = true;
    }

    return Object.keys(merged).length ? merged : undefined;
  };

  /* Apply an editor target's draft settings onto a blocks array. Shared by
     "Save changes" and Publish, so publishing mid-edit keeps what was typed.
     Defined above publish â€” the CI build's no-use-before-define is an error. */
  const applyEditTo = (cur, target, stampWorkspaceIds = []) => {
    const { id, draft: next, pending, size } = target;
    const def = widgetById(id);
    if (!def || !next) return cur;
    if (pending && !cur.some((b) => b.i === id)) {
      const s = mergeBlockSettings(def, null, next, stampWorkspaceIds);
      const dims = sizeDims(id, size) || { w: def.defaultW, h: def.defaultH };
      const bottom = cur.reduce((max, b) => Math.max(max, b.y + b.h), 0);
      return [...cur, { i: id, x: 0, y: bottom, w: dims.w, h: dims.h, ...(s ? { s } : {}) }];
    }
    return cur.map((b) => {
      if (b.i !== id) return b;
      const nb = { i: b.i, x: b.x, y: b.y, w: b.w, h: b.h };
      const s = mergeBlockSettings(def, b.s, next, stampWorkspaceIds);
      return s ? { ...nb, s } : nb;
    });
  };

  const publish = () => {
    /* Fold the open editor draft in before publish — otherwise Publish while
       mid-edit discarded the unsaved panel (and even after Save Changes, a
       second open edit could race). Stamp empty-host board workspaces so
       KOTM/Yeti keep their combined pick after reload. */
    const stamp = shouldInherit ? inheritSources : [];
    let base = draft || [];
    if (editTarget) base = applyEditTo(base, editTarget, stamp);
    const next = conformLayout(base);
    if (!next.length) return;
    setSavedLayout(next);
    setEditing(false);
    setDrawerOpen(false);
    setTemplateOpen(false);
    setDraft(null);
    setEditTarget(null);
    celebratePublish(); // the board is live — the biggest moment gets the biggest burst
    publishLayout(companyId, workspace?._id, next);
    // Pay rules ride along with Publish so there is ONE save button, but they
    // land on the workspace, not the layout.
    if (programDirty && workspace?._id) {
      const clean = sanitizeProgram(program);
      // Call the plain async saver DIRECTLY — UPDATE_BONUS_CONFIG() is a
      // useMutation factory and invoking it from a click handler is an invalid
      // hook call that THROWS synchronously (so the .catch never ran, the save
      // never happened, and BONUS_CONFIG_SAVED_EVENT never fired to refresh the
      // money cards). See api/group.js.
      SAVE_BONUS_CONFIG({ groupId: workspace._id, data: configFromProgram(clean) })
        .catch(() => {}); // the store already mirrored locally; never block publish
      setProgramDirty(false);
    }
  };

  const resetToDefault = () =>
    requestWipe("The default board", DEFAULT_LAYOUT.map((blk) => ({ ...blk })), "Reset board");

  // Keep `s` when the grid reports a move or resize. Rebuilding a block from
  // {i,x,y,w,h} silently throws away everything the editor wrote â€” the same
  // trap sanitizeLayout has. The ghost card is not a real block, so it never
  // enters the draft.
  const onGridChange = (nextLayout) => {
    if (!editing) return;
    const ghost = (editTarget?.pending && editTarget.id) || createGhost?.id || null;
    setDraft((d) => {
      const prev = d || [];
      return nextLayout
        .filter((blk) => blk.i !== ghost)
        .map((blk) => {
          const old = prev.find((o) => o.i === blk.i);
          return { i: blk.i, x: blk.x, y: blk.y, w: blk.w, h: blk.h, ...(old?.s ? { s: old.s } : {}) };
        });
    });
  };

  const removeBlock = (id) => {
    setDraft((d) => (d || []).filter((blk) => blk.i !== id));
    setEditTarget((t) => (t && t.id === id ? null : t));
  };

  /* ── the component editor ──────────────────────────────────────────────── */

  const settingsOf = (id) => {
    // The create ghost renders straight from the form's current draft — that
    // is the whole point of it: pick a metric, see it appear.
    if (createGhost && id === createGhost.id) return createGhost.draft || {};
    if (editTarget && editTarget.id === id) return editTarget.draft;
    return settingsFor((activeLayout || []).find((b) => b.i === id) || { i: id });
  };

  /** Gear in the library: set it up BEFORE it lands. Nothing is added yet. */
  const configureWidget = (id) => {
    setDrawerOpen(true);
    setEditTarget({ id, draft: settingsFor({ i: id }), pending: true, size: "standard" });
  };

  /** Gear on a placed card, or on its tag in the drawer. */
  const editWidget = (id) => {
    setDrawerOpen(true);
    const blk = (draft || []).find((b) => b.i === id);
    setEditTarget({ id, draft: settingsFor(blk || { i: id }), pending: false, size: blk ? sizeKeyOf(blk) : "standard" });
  };

  /* Metrics for the rule composer, from THIS workspace's own KPI list. A
     metric that records the same handful of values on every entry (Memberships
     records a plan) can carry a condition, so one metric supports several
     bonuses — that is what "Clean 365" and "VIP" really are. Free-text details
     like a customer name never group, so they never become a condition. */
  const moneyMetrics = useMemo(() => {
    // Offer EVERY workspace metric, not just publicly displayed ones: a rule
    // can pay on a metric that has no score yet (drafts fresh out of Company
    // Metrics) or one hidden from public boards (scorekeeper-only). Filtering
    // those out made new metrics invisible in Setup until they scored.
    const workspaceDrafts = (draftKpis || []).filter(
      (k) => String(k.groupId) === String(workspace?._id),
    );
    const seen = new Set();
    const rows = [...(allGroupKpis || []), ...workspaceDrafts].filter((k) => {
      if (!k || !(k.title || k.name) || k.disabled) return false;
      if (seen.has(String(k._id))) return false;
      seen.add(String(k._id));
      return true;
    });
    return rows.map((k) => {
      const detail = (bonus?.details || {})[k._id] || null;
      // Keep "%" distinct. Collapsing it into "#" made every percentage look
      // countable, which is how "$10 for every Closed Rate" became offerable —
      // a bonus per percentage cannot mean anything. Setup filters on this.
      const kind = k.kind === "$" || k.kind === "%" ? k.kind : "#";
      return {
        id: k._id,
        label: (k.title || k.name || "").trim(),
        kind,
        detail: detail ? detail.field : null,
        values: detail ? detail.values : null, // [{ value, count }]
      };
    });
  }, [allGroupKpis, draftKpis, workspace, bonus]);

  const myRow = (bonus?.reps || []).find((r) => r.ownerId === userId) || (bonus?.reps || [])[0] || null;
  const money = useMemo(() => {
    if (!program) return null;
    const scored = moneyMetrics.find((m) => m.id === program.scoredOnKpiId);
    // The earnings card is paid on its first commission cut, not on the
    // ladder's scored-on metric — its Basics "Scored on" field must say so.
    const cutKpiId = (program.commissions || []).map((c) => c && c.kpiId).find(Boolean) || null;
    const cut = moneyMetrics.find((m) => m.id === cutKpiId);
    return {
      program,
      metrics: moneyMetrics,
      workspaceName: workspace?.name || "this workspace",
      scoredOnLabel: scored ? scored.label : null,
      earningsScoredOnLabel: cut ? cut.label : null,
      ytd: myRow ? myRow.ytd || 0 : 0,
    };
  }, [program, moneyMetrics, workspace, myRow]);

  const onMoneyChange = (next) => {
    setProgram(next);
    setProgramDirty(true);
  };

  const editChange = (next) => setEditTarget((t) => (t ? { ...t, draft: next } : t));
  const editCancel = () => setEditTarget(null);

  /* Open the drawer on the LIBRARY, never mid-edit. The edit target is separate
     state from `drawerOpen`, so without clearing it here, closing the drawer
     during an edit and reopening it via "Add component" dropped you straight
     back into that same editor. Closing always discards the edit target too. */
  const openDrawer = () => { setEditTarget(null); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setEditTarget(null); setCreateGhost(null); };

  /* Card size lives on the block's w/h (the grid is the truth), not in `s`.
     For a placed card, resize it live so the board updates as you click; for a
     pending one, just remember the choice â€” it is applied on Add. */
  const editSize = (key) => {
    setEditTarget((t) => (t ? { ...t, size: key } : t));
    setEditTarget((t) => {
      if (!t || t.pending) return t;
      const dims = sizeDims(t.id, key);
      if (!dims) return t;
      setDraft((d) => (d || []).map((b) => (b.i === t.id ? { ...b, w: dims.w, h: dims.h } : b)));
      return t;
    });
  };

  /* The card being created or edited is the focus: the page scrolls it into
     view (a ghost is born at the BOTTOM of the board — without this, someone
     at the top clicks "Create a component" and the card takes shape off-screen,
     which is the same as no preview at all), and the canvas dims every other
     card so there is no hunting for which one is changing. */
  const focusId = editing ? (editTarget?.id || createGhost?.id || null) : null;
  useEffect(() => {
    if (!focusId) return undefined;
    /* Two attempts, because one is not enough: the ghost mounts and the hug
       engine spends a few frames resizing rows, and any layout shift cancels an
       in-flight smooth scroll — the first attempt visibly dies mid-glide. The
       second runs after the board has settled and only if the card still is
       not on screen. */
    /* A newborn hugging card keeps re-measuring for a second or two, and every
       reflow either cancels a smooth glide or shifts the target after an
       instant jump has landed — single-shot scrolling lost this race twice.
       So: one smooth glide for feel, then a short settle-watch that nudges
       until the card holds still on screen, and stops. It gives up quickly on
       purpose — past that window, a scroll is the person's own. */
    const el = () => document.querySelector(`[data-block-id="${focusId}"]`);
    const offScreen = () => {
      const e = el();
      if (!e) return false;
      const r = e.getBoundingClientRect();
      return r.top < 0 || r.bottom > window.innerHeight;
    };
    const t1 = setTimeout(() => { if (offScreen()) el().scrollIntoView({ behavior: "smooth", block: "center" }); }, 400);
    let ticks = 0;
    const watch = setInterval(() => {
      ticks += 1;
      if (ticks > 6) { clearInterval(watch); return; }
      /* "instant", not "auto": the app sets `html { scroll-behavior: smooth }`
         globally, which turns "auto" into a glide — and a glide dies at the
         next render. "instant" is the only behavior that bypasses that CSS. */
      if (offScreen()) el().scrollIntoView({ behavior: "instant", block: "center" });
    }, 450);
    return () => { clearTimeout(t1); clearInterval(watch); };
  }, [focusId]);

  /* Width for a custom card, from the size pictures: quarter / half / full.
     Placed cards resize live; the create ghost resizes through createGhost. */
  const editWidth = (id, step) => {
    if (createGhost && id === createGhost.id) {
      setCreateGhost((g) => (g ? { ...g, w: step } : g));
      return;
    }
    setDraft((d) => (d || []).map((b) => {
      if (b.i !== id) return b;
      const floor = customWidthFor(b.s);
      const w = Math.min(GRID_COLS, Math.max(step, floor));
      return { ...b, w, x: Math.min(b.x, GRID_COLS - w) };
    }));
  };

  /* A widget just landed on the board — confetti where the mouse is, and a
     one-shot pop-in on the card. The dashboard is a game, so adding a card
     should feel like a small win, not flash a "Saved" toast. */
  const celebrateBlock = (id, evt) => {
    const origin = evt && typeof evt.clientX === "number"
      ? { x: evt.clientX / window.innerWidth, y: evt.clientY / window.innerHeight }
      : { x: 0.5, y: 0.4 };
    celebrateAdd(origin);
    setPopId(id);
    if (popTimer.current) clearTimeout(popTimer.current);
    popTimer.current = setTimeout(() => setPopId(null), 620);
  };
  useEffect(() => () => { if (popTimer.current) clearTimeout(popTimer.current); }, []);

  const editSave = () => {
    if (!editTarget) return;
    const { id, draft: next, pending, size } = editTarget;
    const def = widgetById(id);
    const stamp = shouldInherit ? inheritSources : [];
    const dims = sizeDims(id, size) || { w: def.defaultW, h: def.defaultH };
    let landed = false;
    setDraft((d) => {
      const cur = d || [];
      if (pending && !cur.some((b) => b.i === id)) {
        landed = true;
        const s = mergeBlockSettings(def, null, next, stamp);
        const bottom = cur.reduce((max, b) => Math.max(max, b.y + b.h), 0);
        const w = def?.custom ? customWidthFor(s) : dims.w;
        return [...cur, { i: id, x: 0, y: bottom, w, h: dims.h, ...(s ? { s } : {}) }];
      }
      return cur.map((b) => {
        if (b.i !== id) return b;
        const nb = { i: b.i, x: b.x, y: b.y, w: b.w, h: b.h };
        const s = mergeBlockSettings(def, b.s, next, stamp);
        /* Adding a second metric (or switching the bonus on) is what earns the
           half width â€” so the card grows with it, instead of squeezing the new
           content into the quarter it was born at. Only when the card is still
           sitting at the width the rule last chose: a width set by hand is the
           player's decision and is left alone. */
        if (def?.custom) {
          const was = customWidthFor(b.s);
          const now = customWidthFor(s);
          if (now !== was && b.w === was) nb.w = Math.min(now, GRID_COLS - b.x);
        }
        return s ? { ...nb, s } : nb;
      });
    });
    // Saving is NOT leaving. This used to call setEditTarget(null), which is
    // exactly what the back arrow does â€” so "Save changes" threw you out to the
    // component library and looked like the edit had been discarded. Stay on
    // the component and confirm instead; only the back arrow navigates.
    setEditTarget((t) => (t ? { ...t, pending: false, savedAt: Date.now() } : t));
    // A gear-configured card just landed on the board â†’ celebrate the add. A
    // plain edit-save shows the "Saved âœ“" button flip in the editor instead
    // (savedAt above), no confetti â€” that would be too much for a small tweak.
    if (landed) celebrateBlock(id);
  };

  // Which library card is mid-drag, so the canvas knows what a drop should create.
  const [draggingId, setDraggingId] = useState(null);

  /** Drop from the library at a grid position, clamped inside the 24 columns. */
  const addBlockAt = (id, x, y) => {
    const def = widgetById(id);
    if (!def) return;
    setDraggingId(null);
    let newId = id;
    setDraft((d) => {
      const cur = d || [];
      /* A component can be added more than once: the extra copies take an
         instance id (earnings#2) so each keeps its own settings and the grid
         still has a unique key per block. */
      newId = makeInstanceId(id, cur);
      const w = def.defaultW;
      const col = Math.max(0, Math.min(Math.round(x), GRID_COLS - w));
      return [...cur, { i: newId, x: col, y: Math.max(0, Math.round(y)), w, h: def.defaultH }];
    });
    celebrateBlock(newId);
  };

  const addBlock = (id, evt) => {
    const def = widgetById(id);
    if (!def) return;
    let newId = id;
    setDraft((d) => {
      const cur = d || [];
      newId = makeInstanceId(id, cur); // second and later copies get earnings#2, #3 …
      const bottom = cur.reduce((max, blk) => Math.max(max, blk.y + blk.h), 0);
      return [...cur, { i: newId, x: 0, y: bottom, w: def.defaultW, h: def.defaultH }];
    });
    celebrateBlock(newId, evt);
  };

  /* Create a "Build your own" widget from the drawer's simple form: mint a fresh
     instance id, carry the chosen metric + graph in its settings, drop it at the
     bottom, and celebrate the add. */
  const createCustom = ({ title, metrics: rows, bonus: rule, look, show, showOn, period, customRange, who, yetiByTeam, yetiBar, yetiGoal, yetiGoals, rphGoal }) => {
    /* If a ghost was live, the new card takes its id — so "Add to board" is the
       dashes turning solid in place, not a second card appearing elsewhere. */
    const id = createGhost?.id || makeCustomId();
    const ghostW = createGhost?.w || null;
    setCreateGhost(null);
    const def = widgetById(id);
    const s = {};
    if (title && title.trim()) s.title = title.trim();
    if (Array.isArray(rows) && rows.length) s.metrics = rows;
    if (rule) s.bonus = rule;
    if (look) s.look = look;
    if (show) s.show = show;
    if (show && showOn) s.showOn = showOn;
    if (period) s.period = period;
    if (period === "custom" && customRange) s.customRange = customRange;
    // Only the OFF state is stored; on is the default.
    if (who === false) s.who = false;
    if (yetiByTeam === true) s.yetiByTeam = true;
    if (yetiBar === true) s.yetiBar = true;
    const goal = normalizeYetiGoal(yetiGoal);
    if (goal) s.yetiGoal = goal;
    const goalsByTeam = normalizeYetiGoals(yetiGoals);
    if (Object.keys(goalsByTeam).length) s.yetiGoals = goalsByTeam;
    if (Number(rphGoal) > 0) s.rphGoal = Number(rphGoal);
    setDraft((d) => {
      const cur = d || [];
      const bottom = cur.reduce((max, blk) => Math.max(max, blk.y + blk.h), 0);
      const w = Math.max(ghostW || 0, customWidthFor(s));
      return [...cur, { i: id, x: 0, y: bottom, w, h: def.defaultH, s }];
    });
    celebrateBlock(id);
  };

  const heroProps = {
    triggerTooltip,
    onNextTooltip: handleNextTooltip,
    closeTooltip: handleCloseTooltip,
    embedded: true, // grid provides the page gutters â€” see Hero.jsx
  };
  /* The money cards on the board must read the PROGRAM BEING EDITED, not the
     frozen server snapshot â€” that is the entire promise of the docked live
     preview ("Watch the card on the board â€” it changes as you edit"). The cards
     derive their rules from `config` via programFromConfig, which reads
     `config.program` first, so overlaying the live program onto the snapshot's
     config makes an added rung or bonus appear the instant it is composed. The
     per-metric `amounts`/`details` stay from the snapshot (spread of
     `...bonus` and `...bonus.config`), so a brand-new rule simply shows with a
     $0 count until real data backs it â€” but it SHOWS. `kpiNames` gets the
     workspace's own KPI labels merged in: the server only names metrics the
     SAVED program references, so a metric picked seconds ago in the editor
     wasn't in the map and the card wrongly printed "metric removed" until the
     next save round-tripped. */
  /* Hidden (archived), deactivated, or moved-out players must not show on the
     money cards. The server filters too (newer builds), but do it here as well
     using the company roster so it holds regardless of which API build is
     serving. Unknown ids are kept â€” the server stays the authority. Totals are
     recomputed from the visible reps so the "All players" view doesn't count
     filtered players. */
  const usersDict = useSelector((state) => state.companyReducer.usersDictionary);
  const visibleBonus = useMemo(() => {
    if (!bonus || !Array.isArray(bonus.reps)) return bonus;
    const dict = usersDict || {};
    const reps = bonus.reps.filter((rep) => {
      if (!isLiveMoneyRep(dict, rep) && !isAverageRep(rep)) return false;
      if (isAverageRep(rep)) return true;
      const u = dict[String(rep.ownerId)] || dict[rep.ownerId];
      const gid = u?.groupId?._id || u?.groupId;
      return !workspace?._id || !gid || String(gid) === String(workspace._id);
    });
    if (reps.length === bonus.reps.length) return bonus;
    const totals = {
      commission: reps.reduce((s, r) => s + (r.commission || 0), 0),
      bonuses: reps.reduce((s, r) => s + (r.earned || 0), 0),
      ytd: reps.reduce((s, r) => s + (r.ytd || 0), 0),
      month: reps.reduce((s, r) => s + (r.month || 0), 0),
      lastMonth: reps.reduce((s, r) => s + (r.lastMonth || 0), 0),
    };
    totals.monthDeltaPct =
      totals.lastMonth > 0
        ? Math.round(((totals.month - totals.lastMonth) / totals.lastMonth) * 100)
        : null;
    return { ...bonus, reps, totals };
  }, [bonus, usersDict, workspace?._id]);

  const liveBonus = useMemo(() => {
    if (!visibleBonus || !program) return visibleBonus;
    const localNames = {};
    moneyMetrics.forEach((m) => { localNames[m.id] = m.label; });
    return {
      ...visibleBonus,
      config: {
        ...(visibleBonus.config || {}),
        ...configFromProgram(program),
        kpiNames: { ...localNames, ...((visibleBonus.config || {}).kpiNames || {}) },
      },
    };
  }, [visibleBonus, program, moneyMetrics]);

  /* Money cards under the period filter. `bonus` above stays the month
     snapshot â€” it also carries the pay program, so it remains the single
     source for the Setup tab. For Today / Yesterday / This Week we call the
     same endpoint with a period window and decorate the result exactly like
     the month one (roster filter + live program overlay). Buckets are fetched
     lazily â€” only the ones a placed money card actually needs â€” and the cache
     resets on workspace change or a ladder save. */
  const [periodBonusRaw, setPeriodBonusRaw] = useState({});
  const inFlightBonus = useRef(new Set());
  useEffect(() => { setPeriodBonusRaw({}); }, [workspace?._id]);
  useEffect(() => {
    const onSaved = () => setPeriodBonusRaw({});
    window.addEventListener(BONUS_CONFIG_SAVED_EVENT, onSaved);
    return () => window.removeEventListener(BONUS_CONFIG_SAVED_EVENT, onSaved);
  }, []);
  const moneyBuckets = useMemo(() => {
    const need = new Set();
    (activeLayout || []).forEach((blk) => {
      if (blk.i !== "earnings" && blk.i !== "milestones") return;
      const s = settingsFor(blk);
      const idx =
        s.period && PERIOD_TO_IDX[s.period] != null ? PERIOD_TO_IDX[s.period] : globalPeriod;
      const b = IDX_TO_BUCKET[idx];
      if (b && b !== "month" && b !== "lastMonth") need.add(b);
    });
    return [...need];
  }, [activeLayout, globalPeriod]);
  useEffect(() => {
    if (!workspace?._id) return;
    moneyBuckets.forEach((bucket) => {
      if (periodBonusRaw[bucket] || inFlightBonus.current.has(bucket)) return;
      inFlightBonus.current.add(bucket);
      FETCH_BONUS_PROGRESS(workspace._id, bucket)
        .then((res) => {
          if (!res) return;
          setPeriodBonusRaw((prev) => ({
            ...prev,
            [bucket]: {
              ...res,
              myId: userId,
              connected: !!(res.config && res.config.revenueKpiId),
            },
          }));
        })
        .catch(() => {})
        .finally(() => inFlightBonus.current.delete(bucket));
    });
  }, [workspace?._id, userId, moneyBuckets, periodBonusRaw]);
  const bonusByBucket = useMemo(() => {
    const dict = usersDict || {};
    const decorate = (raw) => {
      if (!raw) return raw;
      let b = raw;
      if (Array.isArray(b.reps)) {
        const reps = b.reps.filter((rep) => {
          if (!isLiveMoneyRep(dict, rep) && !isAverageRep(rep)) return false;
          if (isAverageRep(rep)) return true;
          const u = dict[String(rep.ownerId)] || dict[rep.ownerId];
          const gid = u?.groupId?._id || u?.groupId;
          return !workspace?._id || !gid || String(gid) === String(workspace._id);
        });
        if (reps.length !== b.reps.length) {
          const totals = {
            commission: reps.reduce((s, r) => s + (r.commission || 0), 0),
            bonuses: reps.reduce((s, r) => s + (r.earned || 0), 0),
            ytd: reps.reduce((s, r) => s + (r.ytd || 0), 0),
            month: reps.reduce((s, r) => s + (r.month || 0), 0),
            lastMonth: reps.reduce((s, r) => s + (r.lastMonth || 0), 0),
          };
          totals.monthDeltaPct =
            totals.lastMonth > 0
              ? Math.round(((totals.month - totals.lastMonth) / totals.lastMonth) * 100)
              : null;
          b = { ...b, reps, totals };
        }
      }
      if (program) {
        const localNames = {};
        moneyMetrics.forEach((m) => { localNames[m.id] = m.label; });
        b = {
          ...b,
          config: {
            ...(b.config || {}),
            ...configFromProgram(program),
            kpiNames: { ...localNames, ...((b.config || {}).kpiNames || {}) },
          },
        };
      }
      return b;
    };
    return {
      yesterday: decorate(periodBonusRaw.yesterday),
      today: decorate(periodBonusRaw.today),
      week: decorate(periodBonusRaw.week),
      lastWeek: decorate(periodBonusRaw.lastWeek),
    };
  }, [periodBonusRaw, usersDict, workspace?._id, program, moneyMetrics]);

  /* The viewing rep's OWN daily series, for "Build your own" trend graphs
     (bar/line/area/spark). Redux only keeps period totals, so we fetch the raw
     per-user daily scores and filter to the logged-in rep, then fold them into a
     by-day map with the same helper the Company Metrics designer uses — one
     user in, that user's own series out. Only fetched when a custom widget is on
     the board or the admin is customizing, so it costs nothing otherwise. */
  const [seriesByDay, setSeriesByDay] = useState(null);
  const needSeries = editing || (savedLayout || []).some((b) => isCustomId(b.i));
  // The trend must read from the SAME place the headline number does: a rep sees
  // their own daily series; an admin sees the team AVERAGE (UseMyKpis shows admins
  // the average, so the line has to too, or it flat-lines while the number reads
  // the team average). The average matches UseMyKpis exactly: active players only
  // (isActive !== false, not the Yeti — the same set it divides by), summed per
  // day, then divided by the active count. Summed over the month that equals the
  // admin headline for additive $/# metrics.
  useEffect(() => {
    if (!needSeries || !companyId || !workspace?._id || !userId) return undefined;
    let alive = true;
    GET_ALL_USER_KPIS(companyId, workspace._id, moment().format("YYYY-MM"))
      .then((res) => {
        if (!alive) return;
        const all = res?.data?.scores || res?.scores || [];
        if (!isRealAdmin) {
          const mine = all.filter((s) => (s.ownerId || s.userId) === userId);
          setSeriesByDay(buildCompanyScoresByDay(mine, moment()));
          return;
        }
        const active = (topPlayers || []).filter((p) => p && p.isActive !== false && p.lastName !== "Yeti");
        const activeIds = new Set(active.map((p) => p.userId));
        const activeCount = active.length || 1;
        const activeScores = all.filter((s) => activeIds.has(s.ownerId || s.userId));
        const total = buildCompanyScoresByDay(activeScores, moment());
        const avg = {};
        Object.entries(total).forEach(([day, obj]) => {
          avg[day] = {};
          Object.entries(obj).forEach(([k, v]) => {
            if (k === "total") avg[day].total = (Number(v) || 0) / activeCount;
            else avg[day][k] = { amt: (Number(v?.amt) || 0) / activeCount, pts: (Number(v?.pts) || 0) / activeCount };
          });
        });
        setSeriesByDay(avg);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [needSeries, companyId, workspace?._id, userId, isRealAdmin, topPlayers]);

  /* Custom components need three more things than the built-ins do: which
     period the navbar filter is on (so a card set to "follow the dashboard"
     actually does), whose numbers are being viewed (so the activity list is the
     right person's), and whether the KPIs are still in flight — a money card
     that renders $0 while loading is stating a wrong number, not an empty one. */
  /* Legacy hooks (UseTopPlayers / UseMyKpis) only understand numeric buckets.
     While Custom range is active they stay on This Month; scoped cards
     (Yeti, mountain, milestones, cross-workspace leaderboard) use boardWindow
     + boardCustom / globalRange instead. */
  const bucketIdx = typeof globalPeriod === "number" ? globalPeriod : 3;

  /* Keep the pick valid: if the board stops being cross-workspace, or the picked
     workspace leaves the board, fall back to All. */
  useEffect(() => {
    if (!hasCombined && boardWs !== "all") setBoardWs("all");
    else if (boardWs !== "all" && !boardWorkspaces.includes(boardWs)) setBoardWs("all");
  }, [hasCombined, boardWorkspaces, boardWs]);

  /* Options for the navbar Viewing filter: All, then each workspace the board
     actually combines — named, in the company's own order. */
  const wsOptions = useMemo(() => {
    const name = {};
    (allWorkspaces || []).forEach((w) => { name[String(w._id)] = w.name; });
    return [
      { value: "all", label: "All workspaces" },
      ...boardWorkspaces.map((id) => ({ value: id, label: name[id] || "Workspace" })),
    ];
  }, [allWorkspaces, boardWorkspaces]);

  /* A quick-edit save path for the rare card that lets an admin change a
     value right on the live board (Payroll vs Revenue's per-employee pay
     rates) instead of through the Setup drawer's Save/Publish flow. Patches
     and publishes that one block immediately — a no-op while the whole-board
     editor is open, so it can never publish another card's unsaved draft
     along with it; the admin exits editing to use it, same as everything
     else that touches the published layout. */
  const saveWidgetSettings = (blockId, patchFn) => {
    if (editing || !blockId || typeof patchFn !== "function") return;
    setSavedLayout((cur) => {
      const base = cur || DEFAULT_LAYOUT;
      if (!base.some((b) => b.i === blockId)) return cur;
      const next = base.map((b) => {
        if (b.i !== blockId) return b;
        const patched = patchFn(settingsFor(b) || {});
        return patched ? { ...b, s: patched } : b;
      });
      const clean = sanitizeLayout(next);
      publishLayout(companyId, workspace?._id, clean);
      return clean;
    });
  };

  const ctx = {
    saveWidgetSettings,
    boardWidgets,
    kpis, kpisAll, isRealAdmin, heroProps, periodIdx: bucketIdx, bonus: liveBonus,
    primary: primaryColor || "#1B598E", seriesByDay,
    periodName: IDX_TO_BUCKET[bucketIdx] || "month",
    /* Host workspace id — scoped cards fall back to UseSelectedWorkspace when
       this is missing; pass it explicitly so Head of Sales / empty hosts still
       resolve a stable ownWorkspaceId for inherit logic. */
    workspaceId: workspace?._id ? String(workspace._id) : null,
    /* A dashboard-wide custom range — only when the navbar is set to Custom. */
    globalRange: globalPeriod === "custom" && (globalRange.from || globalRange.to)
      ? { ...globalRange }
      : null,
    /* Dashboard-wide time control for Follow-dashboard widgets (game + money). */
    boardWindow: globalPeriod === "custom" ? "custom" : (PERIOD_TO_WINDOW[globalPeriod] || "month"),
    boardCustom: globalPeriod === "custom" && (globalRange.from || globalRange.to)
      ? { ...globalRange }
      : null,
    viewingOwnerId: userId,
    kpisLoading: isLoading || lastMonthHistoricPending,
    /* Which card the drawer is open on — a scoped card uses it to explain why
       its workspace dropdown is missing, at the moment you are looking. */
    editingId: editTarget?.id || null,
    /* The board-wide workspace pick. Null unless the board is cross-workspace,
       so a single-workspace board behaves exactly as before. Combined cards read
       it and follow the navbar instead of carrying their own workspace dropdown. */
    boardWs: hasCombined ? boardWs : null,
    /* The union of workspaces this board combines (from any card scoped to 2+).
       A widget on an EMPTY host workspace (e.g. Head of Sales, which tracks no
       metrics of its own) reads these so the leaderboard and money cards show
       the players from the selected workspaces instead of a blank card. */
    boardWorkspaces: hasCombined ? boardWorkspaces : [],
    inheritWorkspaceIds: shouldInherit ? inheritSources : [],
  };

  /* The real workspace metrics offered by the "Build your own" create/edit flow
     — searchable and grouped by their source. Built from `kpisAll` (each row
     carries the viewing rep's own value + target) so a picked metric renders a
     real number, never a dummy. Scorekeeper-only metrics ARE offered here:
     that toggle hides a metric from public boards, but an admin deliberately
     putting it on a custom card is exactly the kind of display it exists for. */
  const metricCatalog = useMemo(
    () => {
      const real = (kpisAll || [])
        .filter((k) => k && !k.isDraft && !k.disabled && (k.title || k.name))
        .map((k) => {
          let wids = [];
          if (k.groupId) wids = [String(k.groupId)];
          else if (workspace?._id) wids = [String(workspace._id)];
          const raw = k.sourceName || k.source;
          let group = workspace?.name || "Manual entry";
          if (typeof raw === "string" && raw.trim() && raw !== "[object Object]") {
            group = raw.trim();
          } else if (raw && typeof raw === "object") {
            const n = raw.name || raw.label || raw.title || raw.code;
            if (typeof n === "string" && n.trim()) group = n.trim();
          } else if (workspace?.name) {
            group = workspace.name;
          }
          let kind = "#";
          if (k.kind === "$" || k.kind === "%") kind = k.kind;
          return {
            id: k._id,
            label: (k.title || k.name || "").trim(),
            kind,
            target: Number(k.target) || 0,
            value: Number(k.amount) || 0,
            group,
            workspaceIds: wids,
          };
        });
      return [
        ...real,
        {
          id: AVG_DAILY_REVENUE_ID, label: "Average Daily Revenue", kind: "$",
          target: 0, value: 0, group: "Derived", workspaceIds: [], derived: true,
        },
        {
          id: TECH_REVENUE_PER_HOUR_ID, label: "Technicians' Revenue per Hour", kind: "$",
          target: 0, value: 0, group: "Derived", workspaceIds: [], derived: true,
        },
        {
          id: BEAT_YETI_RATE_ID, label: "Beat the Yeti rate", kind: "%",
          target: 0, value: 0, group: "Derived", workspaceIds: [], derived: true,
        },
      ];
    },
    [kpisAll, workspace?._id, workspace?.name],
  );

  const renderWidget = (id) => {
    const def = widgetById(id);
    if (!def) return null;
    const s = settingsOf(id);
    // A per-card Period pins this card to its own window; unset = follow the
    // dashboard filter. Applied through ctx so any component that already reads
    // ctx.periodIdx (leaderboard, podium) honours it with no extra wiring.
    // bucketIdx (not globalPeriod) so a dashboard-wide "custom" range still hands
    // the bucket-based cards a real 0–3 index instead of the string "custom".
    const effectiveIdx =
      s.period && PERIOD_TO_IDX[s.period] != null ? PERIOD_TO_IDX[s.period] : bucketIdx;
    // Swap in the period's own KPI summary and bonus snapshot so every widget —
    // not just the leaderboard â€” follows the Today / Yesterday / This Week filter.
    const bucket = IDX_TO_BUCKET[effectiveIdx] || "month";
    const cardCtx = {
      ...ctx,
      periodIdx: effectiveIdx,
      kpis: kpisByPeriod[bucket] || kpis,
      kpisAll: kpisAllByPeriod[bucket] || kpisAll,
      bonus: bucket === "month" ? liveBonus : (bonusByBucket[bucket] ?? liveBonus),
    };
    const node = def.render(cardCtx, s, id);
    if (id === "kotm") {
      return (
        <CustomWidthTooltip
          title={<CustomTooltipContent closeTooltip={closeGameboardTooltip} />}
          placement="right"
          arrow
          open={openGameboardTooltip}
        >
          <div style={{ height: "100%" }}>{node}</div>
        </CustomWidthTooltip>
      );
    }
    if (id === "yeti") {
      return (
        <CustomWidthTooltip
          title={<CustomTooltipContent2 closeTooltip={closeYetiTooltip} onNext={handleNextTooltip2} isAdmin={isAdmin} />}
          placement="left"
          arrow
          open={openYetiTooltip}
        >
          <div style={{ height: "100%" }}>{node}</div>
        </CustomWidthTooltip>
      );
    }
    return node;
  };

  return (
    <SoftBox sx={{ position: "relative" }}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {isLoading ? (
        <SoftBox sx={{ padding: { mini: "0.5rem", xxs: "1.5rem" }, marginTop: "32px" }}>
          <Grid container spacing={3}>
            <Grid item mini={12} lg={8}>
              <Skeleton variant="rect" height={420} radius={16} />
            </Grid>
            <Grid item mini={12} lg={4}>
              <Skeleton variant="rect" height={420} radius={16} />
            </Grid>
            <Grid item mini={12} lg={6}>
              <Skeleton variant="rect" height={280} radius={16} />
            </Grid>
            <Grid item mini={12} lg={6}>
              <Skeleton variant="rect" height={280} radius={16} />
            </Grid>
          </Grid>
        </SoftBox>
      ) : (
        <SoftBox className="gmbw-fade-in">
          <Box>
          {isVisible && <SoftBox className={alert} sx={{padding: { mini: "0.5rem", xxs: "1.5rem 1.5rem 0rem 1.5rem" }, marginTop: "32px"}}>
              <Grid container sx={{padding: "20px", backgroundColor: "#ffffff", alignItems: "center", display: isSmallScreen ? "none" : "flex", borderRadius: "8px" }}>
                <Grid item mini={2}>
                    <SoftTypography sx={{ color: "#000000", fontSize: { mini: "18px", md: "16px" }, lineHeight: "24px", fontWeight: "500" }} variant="h3">
                      Get started with Game My Biz
                    </SoftTypography>
                </Grid>
                <Grid item mini={8}>
                  <div style={{ display: 'flex', }}>
                    <SoftButton color="primary" sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, marginRight: ".5rem", textTransform: "capitalize" }} onClick={() => navigate("/settings/players")}>
                      <svg style={{marginRight: ".5rem"}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="8" cy="8" r="7.66667" fill="#FCFCFD" stroke="#98A2B3" /> <path d="M7.33467 11V5.58667L6.28 5.82933V5.10133L7.72667 4.46667H8.36133V11H7.33467Z" fill="#667085"/> </svg>
                      Invite Players
                    </SoftButton>
                    <SoftButton color="primary" sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, marginRight: ".5rem", textTransform: "capitalize" }} onClick={() => navigate("/gameboard-library")}>
                      <svg style={{marginRight: ".5rem"}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7.66667" fill="#FCFCFD" stroke="#98A2B3" />
                        <path d="M5.532 11V10.2907C5.95511 9.95467 6.35956 9.61556 6.74533 9.27333C7.13111 8.93111 7.47333 8.59511 7.772 8.26533C8.07689 7.92933 8.31644 7.60267 8.49067 7.28533C8.66489 6.96178 8.752 6.65067 8.752 6.352C8.752 6.15289 8.71778 5.96622 8.64933 5.792C8.58089 5.61156 8.46889 5.46844 8.31333 5.36267C8.15778 5.25067 7.94933 5.19467 7.688 5.19467C7.296 5.19467 7.00044 5.31911 6.80133 5.568C6.60844 5.81689 6.51511 6.11555 6.52133 6.464H5.56C5.56622 6.00356 5.66267 5.61778 5.84933 5.30667C6.04222 4.99555 6.29733 4.75911 6.61467 4.59733C6.93822 4.43555 7.30222 4.35467 7.70667 4.35467C8.32267 4.35467 8.81422 4.52889 9.18133 4.87733C9.55467 5.21956 9.74133 5.69867 9.74133 6.31467C9.74133 6.68178 9.65111 7.04578 9.47067 7.40667C9.29645 7.76756 9.06622 8.116 8.78 8.452C8.5 8.78178 8.19822 9.09289 7.87467 9.38533C7.55111 9.67778 7.24311 9.94222 6.95067 10.1787H9.93733V11H5.532Z" fill="#667085"/>
                      </svg>
                      Customize Gameboard
                    </SoftButton>
                    <SoftButton color="primary" sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, textTransform: "capitalize" }} onClick={() => navigate("/workspace-kpi")}>
                      <svg style={{marginRight: ".5rem"}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7.66667" fill="#FCFCFD" stroke="#98A2B3" />
                        <path d="M7.75333 11.112C7.33022 11.112 6.94444 11.0373 6.596 10.888C6.25378 10.7324 5.98 10.4991 5.77467 10.188C5.56933 9.87689 5.46044 9.488 5.448 9.02133H6.428C6.44044 9.36978 6.55867 9.66533 6.78267 9.908C7.01289 10.1444 7.33644 10.2627 7.75333 10.2627C8.15156 10.2627 8.45644 10.1538 8.668 9.936C8.87956 9.712 8.98533 9.43511 8.98533 9.10533C8.98533 8.70711 8.84222 8.41156 8.556 8.21867C8.276 8.02578 7.93067 7.92933 7.52 7.92933H7.03467V7.108H7.52933C7.89644 7.108 8.192 7.02089 8.416 6.84667C8.64622 6.67244 8.76133 6.42667 8.76133 6.10933C8.76133 5.84178 8.67111 5.624 8.49067 5.456C8.31644 5.288 8.06756 5.204 7.744 5.204C7.408 5.204 7.14356 5.30355 6.95067 5.50267C6.75778 5.69555 6.652 5.93822 6.63333 6.23067H5.65333C5.66578 5.85111 5.75911 5.52133 5.93333 5.24133C6.11378 4.96133 6.35956 4.74355 6.67067 4.588C6.98178 4.43244 7.33956 4.35467 7.744 4.35467C8.17956 4.35467 8.54356 4.43244 8.836 4.588C9.13467 4.73733 9.35867 4.94267 9.508 5.204C9.66356 5.45911 9.74133 5.73911 9.74133 6.044C9.74133 6.39244 9.64489 6.69733 9.452 6.95867C9.25911 7.22 9.00089 7.39422 8.67733 7.48133C9.05067 7.56222 9.35867 7.74578 9.60133 8.032C9.844 8.312 9.96533 8.676 9.96533 9.124C9.96533 9.48489 9.88133 9.81778 9.71333 10.1227C9.54533 10.4213 9.29644 10.6609 8.96667 10.8413C8.63689 11.0218 8.23244 11.112 7.75333 11.112Z" fill="#667085"/>
                      </svg>
                      Add metrics
                    </SoftButton>
                    </div>
                </Grid>
                <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }} mini={2}>
                  <SoftButton onClick={() => setOpenModal(true)} sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, textTransform: "capitalize", marginRight: "24px" }}>
                    Interactive Tour
                  </SoftButton>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{cursor: "pointer"}} onClick={handleHide}>
                    <path d="M1.26668 9.66683L0.333344 8.7335L4.06668 5.00016L0.333344 1.26683L1.26668 0.333496L5.00001 4.06683L8.73334 0.333496L9.66668 1.26683L5.93334 5.00016L9.66668 8.7335L8.73334 9.66683L5.00001 5.9335L1.26668 9.66683Z" fill="#000"/>
                  </svg>
                </Grid>
              </Grid>
            </SoftBox>}
            {/* Admins can open the board (and Customize) even on a workspace
                with no metrics of its own — a head-of-sales / aggregator
                workspace intentionally has none and only hosts cross-workspace
                widgets that read metrics from other workspaces. */}
            {(kpis.length || isAdmin) ? (
              // The board ALWAYS makes room while the panel is open — browsing the
              // library, placing a new card, or editing a placed one. Editing used
              // to be the exception: the panel floated over the board so nothing
              // moved. In practice that buried the right-hand cards under the panel
              // exactly when the panel is telling you to watch them change, and it
              // made editing feel like a different mode from creating. One
              // behaviour for one panel: the board narrows, reflows, and every card
              // stays visible beside what you are editing.
              // Master's gutter fix, kept through the merge: the page carries the
              // same side margins as Team Feed (marginX 1rem/1.5rem), not extra
              // canvas padding. Master ALSO carried an old "editing overlays, only
              // adding pushes" behaviour — deliberately NOT taken: Victor retired
              // that (editing pushes like creating; one behaviour for one panel).
              <SoftBox sx={{ marginX: { mini: "1rem", sm: "1.5rem" } }}>
              <div className={`gmbw-root${editing && drawerOpen ? " panel-open" : ""}`} style={brandVars}>
                {/* Controls live in the navbar — portalled so they exist only on this page. */}
                {navSlotLeft && editing &&
                  createPortal(
                    <span className="gmbw-editing-chip" style={brandVars}>
                      <span className="gmbw-editing-dot" />
                      Editing dashboard
                      <span className="gmbw-editing-sub">Â· unsaved changes</span>
                    </span>,
                    navSlotLeft,
                  )}
                {navSlotRight && !isBelowLg &&
                  createPortal(
                    <span className="gmbw-nav-actions" style={brandVars}>
                      {!editing && (
                        <span className="rc-wrap">
                          <LightSelect
                            options={periodOptions}
                            value={rangeOpen ? "custom" : globalPeriod}
                            width={(rangeOpen || globalPeriod === "custom") ? 176 : 132}
                            height={30}
                            fontSize={12}
                            radius={8}
                            onChange={(o) => {
                              /* Custom only takes effect after Apply — selecting
                                 the option alone used to flip boardWindow to
                                 "custom" with an empty range, which fell back to
                                 month-to-date and showed bogus six-digit ranks. */
                              if (o.value === "custom") {
                                setRangeOpen(true);
                                return;
                              }
                              setGlobalPeriod(o.value);
                              setRangeOpen(false);
                              setGlobalRange({ from: "", to: "" });
                            }}
                          />
                          {(rangeOpen || globalPeriod === "custom") && rangeOpen && (
                            <RangeCalendar
                              value={globalRange}
                              onApply={(r) => {
                                const next = {
                                  from: (r && r.from) || "",
                                  to: (r && r.to) || "",
                                };
                                if (!next.from || !next.to) return;
                                setGlobalRange(next);
                                setGlobalPeriod("custom");
                                setRangeOpen(false);
                              }}
                              onClose={() => setRangeOpen(false)}
                            />
                          )}
                        </span>
                      )}

                      {/* Viewing filter — appears only when the board combines
                          two or more workspaces. It is the board's single
                          workspace control: combined cards follow it, so those
                          cards no longer each carry their own workspace dropdown.
                          Automatic by design — there is no switch to enable it;
                          it exists exactly when there is a choice to make. */}
                      {!editing && hasCombined && (
                        <span className="gmbw-viewing">
                          <LightSelect
                            options={wsOptions}
                            value={boardWs}
                            width={boardWs === "all" ? 150 : 168}
                            height={30}
                            fontSize={12}
                            radius={8}
                            onChange={(o) => setBoardWs(o.value)}
                          />
                        </span>
                      )}

                      {isAdmin && !editing && (
                        <button type="button" className="gmbw-btn pill" onClick={startEditing}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <rect x="3" y="3" width="7" height="7" rx="1.5" />
                            <rect x="14" y="3" width="7" height="7" rx="1.5" />
                            <rect x="3" y="14" width="7" height="7" rx="1.5" />
                            <path d="M17.5 14v7M14 17.5h7" />
                          </svg>
                          Customize
                        </button>
                      )}
                      {editing && (
                        <>
                          {/* Editing tools collapsed into one "+ Add ▾" menu so the
                              edit bar stays to three items: Add · Cancel · Publish. */}
                          {/* The old Add ▾ menu, unpacked. Two destinations is
                              not a menu — it is a tab, and putting it in the bar
                              means the mode says what it can do without being
                              opened first. Reset is gone from here entirely: it
                              sat one click from Publish and threw the whole board
                              away. It now lives as "the default board", the last
                              row of the Templates list, where starting over is a
                              choice among boards rather than a lever. */}
                          <span className="gmbw-navtabs" role="tablist" aria-label="Customize">
                            <button
                              type="button"
                              role="tab"
                              aria-selected={drawerOpen && panelTab === "components"}
                              className={`gmbw-navtab${drawerOpen && panelTab === "components" ? " on" : ""}`}
                              onClick={() => { setPanelTab("components"); openDrawer(); }}
                            >
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <rect x="3" y="3" width="7" height="7" rx="1.6" /><rect x="14" y="3" width="7" height="7" rx="1.6" />
                                <rect x="3" y="14" width="7" height="7" rx="1.6" /><rect x="14" y="14" width="7" height="7" rx="1.6" />
                              </svg>
                              Components
                            </button>
                            <button
                              type="button"
                              role="tab"
                              aria-selected={drawerOpen && panelTab === "templates"}
                              className={`gmbw-navtab${drawerOpen && panelTab === "templates" ? " on" : ""}`}
                              onClick={() => { setPanelTab("templates"); openDrawer(); }}
                            >
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M9 9v11" />
                              </svg>
                              Templates
                            </button>
                          </span>
                          <button type="button" className="gmbw-btn quiet" onClick={cancelEditing}>
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="gmbw-btn primary"
                            disabled={!draft || draft.length === 0}
                            title={
                              !draft || draft.length === 0
                                ? "Add at least one component before publishing"
                                : undefined
                            }
                            onClick={publish}
                          >
                            Publish
                          </button>
                        </>
                      )}
                    </span>,
                    navSlotRight,
                  )}
                {layoutReady ? (
                  <div className="gmbw-fade-in">
                    <DashboardCanvas
                      layout={boardLayout}
                      editing={editing}
                      onLayoutChange={onGridChange}
                      onRemove={removeBlock}
                      renderWidget={renderWidget}
                      onStartTemplate={() => setTemplateOpen(true)}
                      onAddComponent={openDrawer}
                      draggingId={draggingId}
                      onDropWidget={addBlockAt}
                      onEditWidget={editWidget}
                      ghostId={ghostId}
                      focusId={focusId}
                      popId={popId}
                    />
                  </div>
                ) : (
                  // The board layout is fetched per workspace (loadLayout), separately
                  // from the isLoading gate above — switching workspaces, or landing here
                  // with isLoading already false, otherwise rendered nothing at all
                  // (activeLayout stays [] until layoutReady, and DashboardCanvas only
                  // shows its own empty-state copy while editing).
                  <LoadingScreen height="480px" logoHeight="120px" />
                )}
                <CustomizeDrawer
                  open={editing && drawerOpen}
                  tab={panelTab}
                  onTab={setPanelTab}
                  onApplyTemplate={(what, layout) => requestWipe(what, layout, "Replace board")}
                  currentLayout={draft || []}
                  onClose={closeDrawer}
                  onAdd={addBlock}
                  onRemove={removeBlock}
                  onDragWidget={setDraggingId}
                  onOpenTemplates={() => { setDrawerOpen(false); setTemplateOpen(true); }}
                  boardIds={(draft || []).map((blk) => blk.i)}
                  brandVars={brandVars}
                  editing={editTarget}
                  onConfigure={configureWidget}
                  onEdit={editWidget}
                  onEditChange={editChange}
                  onEditSize={editSize}
                  onWidth={editWidth}
                  editBlockW={(activeLayout.find((b) => b.i === editTarget?.id) || {}).w || null}
                  money={money}
                  onMoneyChange={onMoneyChange}
                  onEditCancel={editCancel}
                  onEditSave={editSave}
                  metricCatalog={metricCatalog}
                  boardWidgets={boardWidgets}
                  onCreateCustom={createCustom}
                  onCreateStart={() => setCreateGhost({ id: makeCustomId(), draft: {}, w: null })}
                  onCreateDraft={(d, w) => setCreateGhost((g) => (g ? { ...g, draft: d, w } : g))}
                  onCreateEnd={() => setCreateGhost(null)}
                />
                <TemplatePicker
                  open={editing && templateOpen}
                  onClose={() => setTemplateOpen(false)}
                  onApply={(layout, name) => requestWipe(name, layout, "Replace board")}
                  brandVars={brandVars}
                  boardCount={(draft || []).length}
                />

                <ConfirmWipe
                  open={!!wipe}
                  what={wipe?.what}
                  losing={boardTitles()}
                  confirmLabel={wipe?.confirmLabel}
                  brandVars={brandVars}
                  onCancel={() => setWipe(null)}
                  onConfirm={() => {
                    applyTemplate(wipe.layout);
                    setWipe(null);
                  }}
                />
              </div>
              </SoftBox>
            ) : (
              <>
                <Hero triggerTooltip={triggerTooltip} onNextTooltip={handleNextTooltip} closeTooltip={handleCloseTooltip}/>
                {isAdmin && (
                  <Grid
                    container
                    spacing={4}
                    sx={{ padding: { xxs: "1.5rem" },paddingTop: { md: "10px" } }}
                  >
                    <Grid item mini={12} height="10rem">
                      <AddKpiBox />
                    </Grid>
                  </Grid>
                )}
              </>
            )}
            <Box>
              <Footer />
            </Box>
          </Box>
          <Modal open={openModal}>
            <SoftBox sx={style}>
              <SoftBox sx={{textAlign: "center"}}>
                <img src={onBoardingImage} alt="onboarding"/>
                <SoftTypography sx={{color: "#344054", fontWeight: "bold", fontSize: "20px", lineHeight: "24px", marginTop: "2rem"}} variant="h1" component="h1">
                  Welcome to Your GameMyBiz Dashboard!
                </SoftTypography>
                <SoftTypography sx={{color: "#667085", fontWeight: "400", fontSize: "16px", lineHeight: "24px", marginTop: "1rem"}} variant="p" component="p">
                  Get ready to level up your productivity and engagement.<br />
                  Would you like to take a quick tour to learn more?
                </SoftTypography>
                <SoftButton onClick={handleCloseModal}
                    sx={{
                      background: "#F9FAFB",
                      color: "#475467",
                      borderRadius: "8px",
                      marginTop: "2rem",
                      border: "1px solid #EAECF0",
                      boxShadow: "none !important",
                      padding: "16px 32px"
                      }}>
                  Take a quick Product Tour
                </SoftButton>
                <SoftTypography sx={{color: "#667085", fontWeight: "400", fontSize: "16px", lineHeight: "24px", marginTop: "1rem", cursor: "pointer"}} variant="p" component="p" onClick={handleCloseModal2}>
                  Skip Tour and Explore on Your Own
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </Modal>
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default Homepage;
